import Link from "next/link";
import React from "react";
import ContactDetails from "./ContactDetails";

const Contact = () => {
  return (
    <>
      <div className="rainbow-section-gap">
        <div className="container">
          <div className="rbt-dashboard-content">
            <div className="banner-area text-center">
              <div className="content-page settings-area">
                <h3 className="title">Contact Us</h3>
                <span>
                      We understand the challenges faced by farmers and strive to offer expert insights and data-driven solutions to help you maximize yields while minimizing environmental impact.
If you have any queries, suggestions, or feedback regarding our products or services, please don't hesitate to reach out to us. Our dedicated team is ready to assist you and ensure that you have a seamless experience with CyberAgric.
                    </span>
              </div>
            </div>
            <div className="content-page mt--20 pb--50">
              <div className="chat-box-list">
                <div className="content">
                 <div className="content-page pb--50">
              <div className="chat-box-list">
                <ContactDetails />
              </div>
            </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
